import React from "react";
import useStore from "../store";
import strings from "../lang/Localiz";

function HudError() {
    const searchParams = new URLSearchParams(window.location.search);
    const isAndroid = searchParams.get("is_android");
    const buttonAction = searchParams.get("button_action");

    const cell = useStore((state) => state.i);
    const errorType = useStore((state) => state.errorType);
    const closemodalError = useStore((state) => state.closemodalError);
    const modalErrorShow = useStore((state) => state.modalErrorShow);

    const endDate = new Date('2026-01-20T05:00:00'); // TODO изменить на нужную дату

    function checkDate() {
        const currentDate = new Date();
        return currentDate < endDate;
    }

    function sendPostMessage(e) {
        e.preventDefault();
        window.parent.postMessage(searchParams.get("button_action"), "*");
    }

    function logout() {
        localStorage.removeItem("username");
        localStorage.removeItem("token");
        window.location.reload();
    }

    React.useEffect(() => {
        if (errorType == 'ERROR_AUTH_2' || errorType == 'ERROR_AUTH_4') logout()
    }, [errorType])

    if (modalErrorShow) {
        return (
            <div className={"hud-modal"}>
                <div className="close-wrapper" onClick={closemodalError}></div>
                <div className={"hud-modal-content"}>
                    <div className={"hud-title"}>{strings.somethingWrong}</div>

                    <div className={"hud-modal-content-block"}>
                        {!(errorType === "ERROR_ENERGY") && (
                            <>
                                <div className={"found-txt"}>
                                    {strings.reloadPage}
                                    <br/>
                                    [#technical: {cell} : {errorType}]
                                </div>
                                <div onClick={closemodalError} className={"approve-btn"}>
                                    {" "}
                                    {strings.approve}
                                </div>
                            </>
                        )}
                        {errorType === "ERROR_ENERGY" && (
                            <>
                                <div className={"found-txt"}>
                                    {strings.energy.low}
                                    <br/>
                                    {strings.energy.refill}
                                </div>
                                <div className="button-container">
                                    {!isAndroid && buttonAction && checkDate && (
                                        <div
                                            onClick={sendPostMessage}
                                            className={"approve-btn buy-btn"}
                                        >
                                            {strings.buy}
                                        </div>
                                    )}
                                    <div onClick={closemodalError} className={"approve-btn"}>
                                        {strings.approve}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    } else return null;
}

export default HudError;
